namespace $.$$ {
	export class $shm_hitalama_map_table extends $.$shm_hitalama_map_table {
		content() {
			return ( this.controller() as $mol_view & { Workspace(): $mol_view } ).Workspace()
		}
	}
}
